module.exports = __webpack_public_path__ + "assets/back.04e97539.svg";